export interface SearchableOption {
  value: string;
  label: string;
  searchText?: string;
  context?: string;
  disabled?: boolean;
}

/** Preserve caller arrays; use natural alphabetical names and stable identity tiebreaks. */
export function sortSearchableOptions(options: readonly SearchableOption[]): SearchableOption[] {
  const sentinel = (value: string) => value === "" || value === "__ALL__" ? 0 : 1;
  const compare = (a: string, b: string) => a.localeCompare(b, undefined, {
    sensitivity: "base", numeric: true,
  });
  return [...options].sort((a, b) =>
    sentinel(a.value) - sentinel(b.value) || compare(a.label, b.label) || compare(a.value, b.value),
  );
}
